// Traduit les messages d'erreur Supabase Auth en français.
export function translateAuthError(message: string | undefined | null): string {
  if (!message) return 'Une erreur est survenue. Réessayez.';
  const m = message.toLowerCase();

  // Identifiants
  if (m.includes('invalid login credentials')) return 'Email ou mot de passe incorrect.';
  if (m.includes('email not confirmed')) return 'Email non confirmé. Vérifiez votre boîte de réception.';
  if (m.includes('user not found')) return 'Aucun compte trouvé pour cet email.';
  if (m.includes('user from sub claim in jwt does not exist'))
    return 'Ce lien n’est plus valide (compte modifié ou supprimé). Demandez un nouveau lien de réinitialisation.';

  // Tokens / liens
  if (m.includes('token has expired') || m.includes('expired')) return 'Le lien a expiré. Demandez-en un nouveau.';
  if (m.includes('invalid token') || m.includes('invalid jwt') || m.includes('jwt'))
    return 'Lien invalide ou expiré. Demandez un nouveau lien.';
  if (m.includes('otp_expired')) return 'Le code a expiré. Demandez-en un nouveau.';

  // Mot de passe
  if (m.includes('new password should be different') || m.includes('same as the old password'))
    return 'Le nouveau mot de passe doit être différent de l’ancien.';
  const lenMatch = m.match(/at least (\d+)\s*char/);
  if (lenMatch) return `Mot de passe trop court : ${lenMatch[1]} caractères minimum.`;
  if (m.includes('password should be at least')) return 'Mot de passe trop court (8 caractères minimum).';
  if (m.includes('password is too short') || m.includes('too short')) return 'Mot de passe trop court.';
  if (m.includes('password is too weak') || m.includes('weak password'))
    return 'Mot de passe trop faible. Utilisez majuscules, chiffres et symboles.';
  if (m.includes('pwned') || m.includes('compromised') || m.includes('known to be weak') || m.includes('easy to guess'))
    return 'Mot de passe trop simple. Essayez d’ajouter des chiffres, majuscules ou symboles.';

  // Email
  if (m.includes('email address') && m.includes('invalid')) return 'Adresse email invalide.';
  if (m.includes('email rate limit') || m.includes('rate limit'))
    return 'Trop de tentatives. Patientez quelques minutes avant de réessayer.';
  if (m.includes('email already registered') || m.includes('already registered'))
    return 'Un compte existe déjà pour cet email.';

  // Réseau / serveur
  if (m.includes('network') || m.includes('failed to fetch'))
    return 'Problème de connexion. Vérifiez votre réseau et réessayez.';
  if (m.includes('500') || m.includes('internal server')) return 'Erreur serveur. Réessayez dans un instant.';

  // Autorisation
  if (m.includes('not authorized') || m.includes('unauthorized')) return 'Accès non autorisé.';
  if (m.includes('signups not allowed') || m.includes('signup disabled'))
    return 'Les inscriptions sont désactivées. Contactez l’administrateur.';

  return message;
}
